'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BibSeries = require('./components/BibSeries.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BibSeries).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-bib-series/lib/index.js
// module id = 1473
// module chunks = 1